import { useApp, useBehavior, useInput, useTriggerAction } from '@libs/hooks';
import { TWidgetProps } from '@libs/types';
import React from 'react';
import { TCoreInputData } from '../types/data';
import { TCoreInputOptions } from '../types/options';
import { CoreInputView } from './CoreInputView';

const CoreInputWidget = ({ widget }: TWidgetProps<TCoreInputData, TCoreInputOptions>) => {
    const { isHidden, isDisabled } = useBehavior(widget);
    const { triggerActionsByType } = useTriggerAction(widget);
    const { setModal } = useApp();
    const { value, isFocused, isFilled, isError, errorMessage, handleChange, handleBlur, handleFocus } = useInput(widget, {
        isHidden,
        isDisabled,
        triggerActionsByType,
        setModal,
    });

    return (
        <CoreInputView
            widget={widget}
            label={widget.data?.label}
            value={value}
            helperText={isError ? errorMessage : widget.data?.messages?.helperText}
            isError={isError}
            isDisabled={isDisabled}
            isHide={isHidden}
            isFocused={isFocused}
            isFilled={isFilled}
            style={widget.options?.style}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
        />
    );
};

export { CoreInputWidget };
